import React, { ElementType, ReactNode } from 'react'
import { Badge as MUIBadge, SxProps } from '@mui/material'

export interface BadgeProps {
  anchorOrigin?: { horizontal: 'left' | 'right'; vertical: 'bottom' | 'top' }
  badgeContent?: ReactNode
  children?: ReactNode
  color?:
    | 'default'
    | 'disabled'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
  component?: ElementType<any>
  invisible?: boolean
  max?: number
  overlap?: 'circular' | 'rectangular'
  showZero?: boolean
  size?: 'small' | 'medium'
  slotProps?: {
    badge?: {
      sx?: SxProps
    }
  }
  sx?: object
  variant?: 'dot' | 'standard'
}

/**
 * Badge generates a small badge to the top-right
 * of its child(ren).
 */

const Badge = React.forwardRef((props: BadgeProps, ref: any) => {
  const { color, size, slotProps, ...rest } = props

  return (
    <MUIBadge
      color={color !== 'disabled' ? color : undefined}
      slotProps={{
        badge: {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          sx: {
            bgcolor: color === 'disabled' ? 'grey.200' : undefined,
            ...(size === 'small'
              ? {
                  fontSize: '0.67rem',
                  minWidth: '16px',
                  height: '16px',
                  padding: '0 4px'
                }
              : null),
            ...slotProps?.badge?.sx
          }
        }
      }}
      {...rest}
      ref={ref}
    >
      {props.children}
    </MUIBadge>
  )
})

Badge.displayName = 'Badge'
export default Badge
